var _path, _path2, _path3, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCsvThumb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 33,
    viewBox: "0 0 25 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 32.9992H23.5C24.3284 32.9992 25 32.3276 25 31.4992V7.85516C25 7.43454 24.8234 7.03325 24.5133 6.74913L18.93 1.6342C18.6534 1.3808 18.2919 1.24023 17.9168 1.24023H1.5C0.671573 1.24023 0 1.91181 0 2.74023V31.4992C0 32.3276 0.671573 32.9992 1.5 32.9992Z",
    fill: "#E9E9E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.0762H25V31.5008C25 32.3293 24.3284 33.0008 23.5 33.0008H1.5C0.671573 33.0008 0 32.3293 0 31.5008V23.0762Z",
    fill: "#84BD5A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56641 29.252H9.31641C9.27734 29.6113 9.17448 29.9329 9.00781 30.2168C8.84115 30.5007 8.60547 30.7259 8.30078 30.8926C7.99609 31.0566 7.61589 31.1387 7.16016 31.1387C6.82682 31.1387 6.52344 31.0762 6.25 30.9512C5.97917 30.8262 5.74609 30.6491 5.55078 30.4199C5.35547 30.1882 5.20443 29.9108 5.09766 29.5879C4.99349 29.2624 4.94141 28.9004 4.94141 28.502V27.9355C4.94141 27.5371 4.99349 27.1764 5.09766 26.8535C5.20443 26.528 5.35677 26.2493 5.55469 26.0176C5.75521 25.7858 5.99609 25.6074 6.27734 25.4824C6.55859 25.3574 6.875 25.2949 7.22656 25.2949C7.65625 25.2949 8.01953 25.3757 8.31641 25.5371C8.61328 25.6986 8.84375 25.9225 9.00781 26.209C9.17448 26.4928 9.27734 26.8223 9.31641 27.1973H8.56641C8.52995 26.9316 8.46224 26.7038 8.36328 26.5137C8.26432 26.321 8.1237 26.1725 7.94141 26.0684C7.75911 25.9642 7.52083 25.9121 7.22656 25.9121C6.97396 25.9121 6.7513 25.9603 6.55859 26.0566C6.36849 26.153 6.20833 26.2897 6.07812 26.4668C5.95052 26.6439 5.85417 26.8561 5.78906 27.1035C5.72396 27.3509 5.69141 27.6257 5.69141 27.9277V28.502C5.69141 28.7806 5.72005 29.0423 5.77734 29.2871C5.83724 29.5319 5.92708 29.7467 6.04688 29.9316C6.16667 30.1165 6.31901 30.2624 6.50391 30.3691C6.6888 30.4733 6.90755 30.5254 7.16016 30.5254C7.48047 30.5254 7.73568 30.4746 7.92578 30.373C8.11589 30.2715 8.25911 30.1257 8.35547 29.9355C8.45443 29.7454 8.52474 29.5176 8.56641 29.252ZM13.375 29.623C13.375 29.4902 13.3542 29.373 13.3125 29.2715C13.2734 29.1673 13.2031 29.0736 13.1016 28.9902C13.0026 28.9069 12.8646 28.8275 12.6875 28.752C12.513 28.6764 12.2917 28.5996 12.0234 28.5215C11.7422 28.4382 11.4883 28.3457 11.2617 28.2441C11.0352 28.14 10.8411 28.0215 10.6797 27.8887C10.5182 27.7559 10.3945 27.6035 10.3086 27.4316C10.2227 27.2598 10.1797 27.0632 10.1797 26.8418C10.1797 26.6204 10.2253 26.416 10.3164 26.2285C10.4076 26.041 10.5378 25.8783 10.707 25.7402C10.8789 25.5996 11.0833 25.4902 11.3203 25.4121C11.5573 25.334 11.8216 25.2949 12.1133 25.2949C12.5404 25.2949 12.9023 25.377 13.1992 25.541C13.4987 25.7025 13.7266 25.9147 13.8828 26.1777C14.0391 26.4382 14.1172 26.7168 14.1172 27.0137H13.3672C13.3672 26.8001 13.3216 26.6113 13.2305 26.4473C13.1393 26.2806 13.0013 26.1504 12.8164 26.0566C12.6315 25.9603 12.3971 25.9121 12.1133 25.9121C11.8451 25.9121 11.6237 25.9525 11.4492 26.0332C11.2747 26.1139 11.1445 26.2233 11.0586 26.3613C10.9753 26.4993 10.9336 26.6569 10.9336 26.834C10.9336 26.9538 10.9583 27.0632 11.0078 27.1621C11.0599 27.2585 11.1393 27.3483 11.2461 27.4316C11.3555 27.515 11.4935 27.5918 11.6602 27.6621C11.8294 27.7324 12.0312 27.8001 12.2656 27.8652C12.5885 27.9564 12.8672 28.0579 13.1016 28.1699C13.3359 28.2819 13.5286 28.4082 13.6797 28.5488C13.8333 28.6868 13.9466 28.8444 14.0195 29.0215C14.0951 29.196 14.1328 29.3939 14.1328 29.6152C14.1328 29.847 14.0859 30.0566 13.9922 30.2441C13.8984 30.4316 13.7643 30.5918 13.5898 30.7246C13.4154 30.8574 13.2057 30.9603 12.9609 31.0332C12.7188 31.1035 12.4479 31.1387 12.1484 31.1387C11.8854 31.1387 11.6263 31.1022 11.3711 31.0293C11.1185 30.9564 10.888 30.847 10.6797 30.7012C10.474 30.5553 10.3086 30.3757 10.1836 30.1621C10.0612 29.946 10 29.696 10 29.4121H10.75C10.75 29.6074 10.7878 29.7754 10.8633 29.916C10.9388 30.054 11.0417 30.1686 11.1719 30.2598C11.3047 30.3509 11.4544 30.4186 11.6211 30.4629C11.7904 30.5046 11.9661 30.5254 12.1484 30.5254C12.4115 30.5254 12.6341 30.4889 12.8164 30.416C12.9987 30.3431 13.1367 30.2389 13.2305 30.1035C13.3268 29.9681 13.375 29.8079 13.375 29.623ZM16.9297 30.1973L18.6055 25.373H19.4219L17.3164 31.0605H16.7344L16.9297 30.1973ZM15.3633 25.373L17.0234 30.1973L17.2305 31.0605H16.6484L14.5469 25.373H15.3633Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.6,
    y1: 13.2945,
    x2: 6.4,
    y2: 13.2945,
    stroke: "#559C75",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8.6,
    y1: 13.2945,
    x2: 21.4,
    y2: 13.2945,
    stroke: "#559C75",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 3.6,
    y1: 10.318,
    x2: 6.4,
    y2: 10.318,
    stroke: "#559C75",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 8.6,
    y1: 10.318,
    x2: 21.4,
    y2: 10.318,
    stroke: "#559C75",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 3.6,
    y1: 7.33945,
    x2: 6.4,
    y2: 7.33945,
    stroke: "#559C75",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 8.6,
    y1: 7.33945,
    x2: 21.4,
    y2: 7.33945,
    stroke: "#559C75",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 3.6,
    y1: 16.2711,
    x2: 6.4,
    y2: 16.2711,
    stroke: "#559C75",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 8.6,
    y1: 16.2711,
    x2: 21.4,
    y2: 16.2711,
    stroke: "#559C75",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5015 1.35003C22.5278 3.61536 24.6716 6.69211 24.8447 7.19661L18.5026 7.19661C18.5026 7.19661 18.5035 1.45815 18.5015 1.35003Z",
    fill: "#D9D7CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsvThumb);
export default __webpack_public_path__ + "static/media/csv-thumb.ea9a6a5391c0cdfbb91536cf36694ac9.svg";
export { ForwardRef as ReactComponent };